import React, { useEffect, useState } from "react"
import Button from "../components/Button"
import AuthCard from "../components/AuthCard"
import requests from "../api/requests"
import { errorSnackBar } from "../components/snackBarOptions"
import { useSnackbar } from "react-simple-snackbar"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { logout } from "../app/features/userSlice"
import { Skeleton } from "@mui/material"

function UnpaidScreen() {
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingSubscription, setIsLoadingSubscription] = useState(false)
  const [openErrorSnackbar] = useSnackbar(errorSnackBar)
  const [subscriptionStatus, setSubscriptionStatus] = useState(null)

  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    const featchUserSubscription = async () => {
      try {
        setIsLoadingSubscription(true)
        const subscriptions = await requests.getUserSubscription()
        setSubscriptionStatus(subscriptions?.data?.status)
        if (
          subscriptions?.data?.status &&
          (subscriptions.data.status === "active" ||
            subscriptions.data.status === "trialing")
        ) {
          navigate("/")
          return
        }
      } catch (error) {
        openErrorSnackbar("Erro ao acessar a assinatura")
      } finally {
        setIsLoadingSubscription(false)
      }
    }

    featchUserSubscription()
  }, [navigate])

  const loadPortal = async () => {
    let resp = null
    try {
      setIsLoading(true)
      resp = await requests.createPortalSession({
        returnURL: window.location.origin,
      })
    } catch (error) {
      openErrorSnackbar("Erro ao acessar o portal de pagamento")
    } finally {
      setIsLoading(false)
    }

    if (resp?.data?.url) {
      window.location.href = resp.data.url
    }
  }

  const handleLogout = async () => {
    try {
      await requests.logout()
      dispatch(logout())
    } catch {
      dispatch(logout())
    }
  }

  const logoutLink = (
    <p className="unpaid__logout-link" onClick={handleLogout}>
      Sair da conta
    </p>
  )

  if (isLoadingSubscription) {
    return (
      <AuthCard>
        <Skeleton variant="text" width="60%" height={40} style={{ marginBottom: "16px" }} />
        <Skeleton variant="text" width="100%" height={20} style={{ marginBottom: "8px" }} />
        <Skeleton variant="text" width="90%" height={20} style={{ marginBottom: "8px" }} />
        <Skeleton variant="text" width="80%" height={20} style={{ marginBottom: "24px" }} />
        <Skeleton variant="rectangular" width="100%" height={46} style={{ borderRadius: "8px" }} />
      </AuthCard>
    )
  }

  if (subscriptionStatus === "canceled") {
    return (
      <AuthCard>
        <h1>Assinatura Cancelada</h1>
        <h2>Sua assinatura foi cancelada. Reative sua conta para voltar a acessar o Cosmo Clube.</h2>
        <Button
          onClick={() => navigate("/plan")}
          text="Reativar Assinatura"
          isLoading={isLoading}
        />
        {logoutLink}
      </AuthCard>
    )
  }

  return (
    <AuthCard>
      <h1>Pagamento Falhou</h1>
      <h2>Atualize sua forma de pagamento para continuar acessando o Cosmo Clube.</h2>
      <Button
        onClick={loadPortal}
        text="Atualizar Pagamento"
        isLoading={isLoading}
      />
      {logoutLink}
    </AuthCard>
  )
}

export default UnpaidScreen
